'use client';

import { T } from '@tolgee/react';
import { Hexagon } from 'lucide-react';
import Link from 'next/link';

import { Card } from '@/components/ui/card';

export default function NothingToShowYetPage() {
  return (
    <Card className="relative z-0 mx-auto w-full max-w-md overflow-hidden border-none bg-gradient-to-br from-slate-800 to-slate-900 shadow-xl">
      <div className="absolute inset-0 bg-gradient-to-r from-[#65A30D]/10 to-[#4D7C0F]/10 opacity-60" />
      <div className="relative space-y-6 p-8 text-center">
        <div className="mx-auto flex size-16 items-center justify-center rounded-full bg-gradient-to-r from-[#65A30D] to-[#4D7C0F] shadow-lg">
          <Hexagon className="size-8 text-white" />
        </div>
        <div className="space-y-2">
          <h3 className="text-2xl font-semibold text-white">
            <T keyName="nothing_to_show_yet.title">Nothing to Show Yet</T>
          </h3>
          <p className="text-slate-300">
            <T keyName="nothing_to_show_yet.description">
              We&apos;re working on something exciting! Create an account to get started.
            </T>
          </p>
        </div>
        <Link
          href="/sign-up"
          className="inline-block rounded-md border-0 bg-gradient-to-r from-[#65A30D] to-[#4D7C0F] px-4 py-2 font-medium text-white shadow-md transition-opacity hover:opacity-90">
          <T keyName="nothing_to_show_yet.cta">Sign Up</T>
        </Link>
      </div>
    </Card>
  );
}
